/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  BadRequestResponse,
  ConflictResponse,
  CreateNoteBody,
  DeleteNote200,
  ForbiddenResponse,
  GetNoteHistory200,
  GetNotes200,
  ImproveNote200,
  ImproveNoteBody,
  ImproveNotePublic200,
  ImproveNotePublic429,
  ImproveNotePublicBody,
  InternalServerErrorResponse,
  NotFoundResponse,
  Note,
  UnauthorizedResponse,
  UpdateNoteBody
} from '.././model'
import { customInstance } from '../../custom-instance';


// eslint-disable-next-line
  type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;


/**
 * @summary Retrieves all notes for a case
 */
export const getNotes = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetNotes200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes`, method: 'get', signal
    },
      options);
    }
  

export const getGetNotesQueryKey = (organizationId: string,
    projectId: string,) => {
    
    return [`https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes`] as const;
    }

    
export const getGetNotesQueryOptions = <TData = Awaited<ReturnType<typeof getNotes>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotesQueryKey(organizationId,projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotes>>> = ({ signal }) => getNotes(organizationId,projectId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotesQueryResult = NonNullable<Awaited<ReturnType<typeof getNotes>>>
export type GetNotesQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Retrieves all notes for a case
 */
export const useGetNotes = <TData = Awaited<ReturnType<typeof getNotes>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNotesQueryOptions(organizationId,projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Creates new note
 */
export const createNote = (
    organizationId: string,
    projectId: string,
    createNoteBody: CreateNoteBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Note>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: createNoteBody
    },
      options);
    }
  


export const getCreateNoteMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNote>>, TError,{organizationId: string;projectId: string;data: CreateNoteBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createNote>>, TError,{organizationId: string;projectId: string;data: CreateNoteBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNote>>, {organizationId: string;projectId: string;data: CreateNoteBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  createNote(organizationId,projectId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createNote>>>
    export type CreateNoteMutationBody = CreateNoteBody
    export type CreateNoteMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Creates new note
 */
export const useCreateNote = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNote>>, TError,{organizationId: string;projectId: string;data: CreateNoteBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getCreateNoteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Updates note content (auto-save endpoint)
 */
export const updateNote = (
    organizationId: string,
    projectId: string,
    noteId: string,
    updateNoteBody: UpdateNoteBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Note>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes/${noteId}`, method: 'put',
      headers: {'Content-Type': 'application/json', },
      data: updateNoteBody
    },
      options);
    }
  


export const getUpdateNoteMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNote>>, TError,{organizationId: string;projectId: string;noteId: string;data: UpdateNoteBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNote>>, TError,{organizationId: string;projectId: string;noteId: string;data: UpdateNoteBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNote>>, {organizationId: string;projectId: string;noteId: string;data: UpdateNoteBody}> = (props) => {
          const {organizationId,projectId,noteId,data} = props ?? {};

          return  updateNote(organizationId,projectId,noteId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateNote>>>
    export type UpdateNoteMutationBody = UpdateNoteBody
    export type UpdateNoteMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Updates note content (auto-save endpoint)
 */
export const useUpdateNote = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNote>>, TError,{organizationId: string;projectId: string;noteId: string;data: UpdateNoteBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getUpdateNoteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Deletes a note
 */
export const deleteNote = (
    organizationId: string,
    projectId: string,
    noteId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteNote200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes/${noteId}`, method: 'delete'
    },
      options);
    }
  


export const getDeleteNoteMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,{organizationId: string;projectId: string;noteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,{organizationId: string;projectId: string;noteId: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNote>>, {organizationId: string;projectId: string;noteId: string}> = (props) => {
          const {organizationId,projectId,noteId} = props ?? {};

          return  deleteNote(organizationId,projectId,noteId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNote>>>
    
    export type DeleteNoteMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Deletes a note
 */
export const useDeleteNote = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,{organizationId: string;projectId: string;noteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getDeleteNoteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Retrieves note version history
 */
export const getNoteHistory = (
    organizationId: string,
    projectId: string,
    noteId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetNoteHistory200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes/${noteId}/history`, method: 'get', signal
    },
      options);
    }
  

export const getGetNoteHistoryQueryKey = (organizationId: string,
    projectId: string,
    noteId: string,) => {
    
    return [`https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/notes/${noteId}/history`] as const;
    }

    
export const getGetNoteHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getNoteHistory>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string,
    noteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoteHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNoteHistoryQueryKey(organizationId,projectId,noteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNoteHistory>>> = ({ signal }) => getNoteHistory(organizationId,projectId,noteId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && projectId && noteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNoteHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNoteHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getNoteHistory>>>
export type GetNoteHistoryQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Retrieves note version history
 */
export const useGetNoteHistory = <TData = Awaited<ReturnType<typeof getNoteHistory>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    noteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoteHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNoteHistoryQueryOptions(organizationId,projectId,noteId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * Takes an original note and improvement instructions, uses AI to enhance the note, and returns the improved version
 * @summary Improve note text using AI
 */
export const improveNote = (
    improveNoteBody: ImproveNoteBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ImproveNote200>(
      {url: `https://api.app.usesky.ai/organizations/notes/improve`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: improveNoteBody
    },
      options);
    }
  


export const getImproveNoteMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof improveNote>>, TError,{data: ImproveNoteBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof improveNote>>, TError,{data: ImproveNoteBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof improveNote>>, {data: ImproveNoteBody}> = (props) => {
          const {data} = props ?? {};

          return  improveNote(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ImproveNoteMutationResult = NonNullable<Awaited<ReturnType<typeof improveNote>>>
    export type ImproveNoteMutationBody = ImproveNoteBody
    export type ImproveNoteMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Improve note text using AI
 */
export const useImproveNote = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof improveNote>>, TError,{data: ImproveNoteBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getImproveNoteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Public endpoint that takes an original note and improvement instructions, uses AI to enhance the note, and returns the improved version. This endpoint has rate limiting based on IP address and doesn't require authentication.
 * @summary Improve note text using AI (public endpoint)
 */
export const improveNotePublic = (
    improveNotePublicBody: ImproveNotePublicBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ImproveNotePublic200>(
      {url: `https://api.app.usesky.ai/organizations/notes/improve/public`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: improveNotePublicBody
    },
      options);
    }
  


export const getImproveNotePublicMutationOptions = <TError = BadRequestResponse | ImproveNotePublic429 | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof improveNotePublic>>, TError,{data: ImproveNotePublicBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof improveNotePublic>>, TError,{data: ImproveNotePublicBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof improveNotePublic>>, {data: ImproveNotePublicBody}> = (props) => {
          const {data} = props ?? {};

          return  improveNotePublic(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ImproveNotePublicMutationResult = NonNullable<Awaited<ReturnType<typeof improveNotePublic>>>
    export type ImproveNotePublicMutationBody = ImproveNotePublicBody
    export type ImproveNotePublicMutationError = BadRequestResponse | ImproveNotePublic429 | InternalServerErrorResponse

    /**
 * @summary Improve note text using AI (public endpoint)
 */
export const useImproveNotePublic = <TError = BadRequestResponse | ImproveNotePublic429 | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof improveNotePublic>>, TError,{data: ImproveNotePublicBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getImproveNotePublicMutationOptions(options);

      return useMutation(mutationOptions);
    }
    